import React, { useState } from 'react';
import { useNoteAttachmentUrl } from '../hooks/useNoteAttachmentUrl';

interface NoteImageProps {
  noteId: number;
  imageId: number;
  alt: string;
  className?: string;
}

// Plan 67b: wraps <img> with a presigned-URL fetch keyed on noteId + imageId.
// If the image fails to load (expired signature, transient network),
// refetches once.
const NoteImage: React.FC<NoteImageProps> = ({ noteId, imageId, alt, className }) => {
  const { url, loading, error, refetch } = useNoteAttachmentUrl(noteId, imageId);
  const [retried, setRetried] = useState(false);

  if (loading && !url) {
    return <span className={className} aria-label="Loading image" />;
  }
  if (error || !url) {
    return (
      <span className={className} title={error || 'Image unavailable'}>
        <span className="text-xs text-muted-foreground">image unavailable</span>
      </span>
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      className={className}
      onError={() => {
        if (retried) return;
        setRetried(true);
        refetch();
      }}
    />
  );
};

export default NoteImage;
